module.exports = __webpack_public_path__ + "static/media/GREEN35.5d51232a.jpeg";